import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterstitialTriggerDirective } from './interstitial-trigger.directive';
import { InterstitialModalModule } from '@finder/shared/components/interstitial-modal/interstitial-modal.module';

@NgModule({
    imports: [
        CommonModule,
        InterstitialModalModule
    ],
    declarations: [
        InterstitialTriggerDirective
    ],
    providers: [],
    exports: [
        InterstitialTriggerDirective
    ]
})
export class InterstitialTriggerModule { }
